export enum TipoLeitura {
    AGUA = 'A',
    GAS = 'G'
}